import { render } from "./Awakers.vue?vue&type=template&id=5284abe6&scoped=true&ts=true"
import script from "./Awakers.vue?vue&type=script&lang=ts"
export * from "./Awakers.vue?vue&type=script&lang=ts"

import "./Awakers.vue?vue&type=style&index=0&id=5284abe6&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5284abe6"]])

export default __exports__